export default __webpack_public_path__ + "static/media/aerosensa_50.b8deb556.webp";